'use strict';

// Vue
import Vue from 'vue';

// 3rd party
import moment from 'moment';

// API
import {
  requestAllMessages,
  requestSendMessage,
  requestAllContacts,
  requestContactById,
  requestMessageById,
  //markMessageAsRead,
  //requestUnreadCount,
  sendDocument,
  sendDocumentMeta,
  requestAllConversations,
  markAsRead,
} from 'api/messaging';
// State
const state = {
  stage: 'inbox',
  allMessages: {},
  unreadCount: 0,
  selectedContact: {},
  selectedMessage: {},
  documentIDs: [],
  messageSending: false,
  sentStatus: false,
  next: null,
  previous: null,
  providerList:[],
};

// Getters
const getters = {
  getSelectedContact: state => state.selectedContact,
  getSelectedMessage: state => state.selectedMessage,
  getAllContacts: state => state.contacts,
  getInbox: state => state.allMessages.inbox,
  getOutbox: state => state.allMessages.outbox,
  getAllMessages: state => state.allMessages,
  getStage: state => state.stage,
  getDocumentIDs: state => state.documentIDs,
  getMessageSending: state => state.messageSending,
  getSentStatus: state => state.sentStatus,
  getNext: state => state.next,
  getPrevious: state => state.previous,
  unreadCount: state => state.unreadCount,
  providerList: state => state.providerList,
};

// Mutations
const mutations = {
  SAVE_SELECTED_CONTACT (state, contact) {
    Vue.set(state, 'selectedContact', contact);
  },
  SAVE_SELECTED_MESSAGE (state, message) {
    Vue.set(state, 'selectedMessage', message);
  },
  SAVE_INBOX (state, payload) {
    Vue.set(state.allMessages, 'inbox', payload);
  },
  SAVE_OUTBOX (state, payload) {
    Vue.set(state.allMessages, 'outbox', payload);
  },
  SET_STAGE (state, stage) {
    Vue.set(state, 'stage', stage);
  },
  DELETE_SELECTED_CONTACT (state, contact) {
    Vue.set(state, 'selectedContact', contact);
  },
  SAVE_ALL_CONTACTS (state, contacts) {
    Vue.set(state, 'contacts', contacts);
  },
  RESET_UNREAD_COUNT (state) {
    Vue.set(state, 'unreadCount', 0);
  },
  RESET_PROVIDER_LIST (state) {
    Vue.set(state, 'providerList', []);
  },
  SAVE_DOCUMENT_IDS (state, payload) {
    state.documentIDs.push(payload);
  },
  CLEAR_DOCUMENT_IDS (state) {
    Vue.set(state, 'documentIDs', []);
  },
  SET_MESSAGE_SENDING (state, payload) {
    Vue.set(state, 'messageSending', payload);
  },
  SET_SENT_STATUS (state, payload) {
    Vue.set(state, 'sentStatus', payload);
  },
  SET_NEXT (state, payload) {
    Vue.set(state, 'next', payload);
  },
  SET_PREVIOUS (state, payload) {
    Vue.set(state, 'previous', payload);
  },
  SET_UNREAD_COUNT(state, unreadCount) {
    Vue.set(state, 'unreadCount', unreadCount);
  },
  SET_PROVIDER_LIST(state, providerList) {
    Vue.set(state, 'providerList', providerList);
  },
};

// Actions
const actions = {

  setStage({ commit }, stage) {
    commit('SET_STAGE', stage);
  },

  saveSelectedContact({ commit }, contact) {
    commit('SAVE_SELECTED_CONTACT_TO_STORE', contact);
  },

  deleteSelectedContact({ commit }) {
    commit('DELETE_SELECTED_CONTACT', null);
  },

  requestAllMessages({ commit, rootGetters }, payload) {
    commit('auth/SET_HEADERS', 'fueled', { root: true });
    return new Promise((resolve, reject) => {
      let page = null;

      if(payload.direction) {
        payload.direction === 'next' ? page = rootGetters['messaging/getNext'] : page = rootGetters['messaging/getPrevious'];
      }

      requestAllMessages(page, payload.filter)
        .then(response => {
          const inbox = [];
          const outbox = [];
          const results = response.data.results;

          const pagination = direction => response.data[direction] ? response.data[direction].substring(response.data[direction].lastIndexOf('?') + 1, response.data[direction].lastIndexOf('&')) : '';

          results.forEach(msg => {
            msg.cleanDate = moment(msg.date_time).format('MMM D') === moment().format('MMM D') ? msg.cleanDate = moment(msg.date_time).format('HH:mm') : moment(msg.date_time).format('MMM D');

            msg.from_id === JSON.parse(localStorage.getItem('updateUser')).mdlive_id ? outbox.push(msg) : inbox.push(msg);
          });
          commit('SAVE_INBOX', inbox);
          commit('SAVE_OUTBOX', outbox);
          commit('SET_NEXT', pagination('next'));
          commit('SET_PREVIOUS', pagination('previous'));
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  requestMessageById({ commit }, id) {
    commit('auth/SET_HEADERS', 'fueled', { root: true });
    return new Promise((resolve, reject) => {
      requestMessageById(id)
        .then(response => {
          commit('SAVE_SELECTED_MESSAGE', response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  requestAllContacts({ commit }) {
    commit('auth/SET_HEADERS', 'fueled', { root: true });
    return new Promise((resolve, reject) => {
      requestAllContacts()
        .then(response => {
          commit('SAVE_ALL_CONTACTS', response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  requestContactById({ commit }, id) {
    commit('auth/SET_HEADERS', 'fueled', { root: true });
    return new Promise((resolve, reject) => {
      requestContactById(id)
        .then(response => {
          commit('SAVE_SELECTED_CONTACT', response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  async markAsRead({ commit, dispatch }, model) {
    const user = JSON.parse(localStorage.getItem('updateUser'));
    model.patient = user.mdlive_id;
    model.token = user.md_live.jwt;

    try {
      await markAsRead(model).then(() => {
        dispatch('fetchProviderList',commit);
      });
    } catch (error) {
      console.error('Error in markAsRead:', error);
    }
  },

  // markMessageAsRead(context, id) {
  //   markMessageAsRead(id);
  // },

  // requestUnreadCount({ commit }) {
  //   commit('auth/SET_HEADERS', 'fueled', { root: true });
  //   return new Promise((resolve, reject) => {
  //     requestUnreadCount()
  //       .then(response => {
  //         commit('UPDATE_UNREAD_COUNT', response.data.count);
  //       })
  //       .catch(error => {
  //         console.error(error);
  //         reject(error);
  //       });
  //   });
  // },

  // resetUnreadCount({ commit }) {
  //   commit('RESET_UNREAD_COUNT');
  // },

  async requestSendMessage({ commit, rootGetters, dispatch, state }, model) {

    commit('SET_MESSAGE_SENDING', true);

    // So all the files can be encoded, sent to MDLive, then to backend, then back to us, then added to the original message.

    async function asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    }

    const readUploadedFileAsDataUrl = (inputFile) => {
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onerror = () => {
          reader.abort();
          reject(console.error('Problem parsing input file.'));
        };

        reader.onload = () => {
          const cleanedResponse = reader.result.split(',', 2);
          resolve(cleanedResponse[1]);
        };
        reader.readAsDataURL(inputFile);
      });
    };


    if(rootGetters['forms/getFiles'].length > 0) {

      const uploadFilesAndSendMessage = async () => {

        await asyncForEach(rootGetters['forms/getFiles'], async (file) => {
          const docModel = {};
          docModel.document_name = file.name;
          docModel.data = await readUploadedFileAsDataUrl(file);
          docModel.mime_type = file.type;
          docModel.record_type = 'Patient Record';
          await dispatch('sendDocument', docModel);
        });

        commit('auth/SET_HEADERS', 'fueled', { root: true });
        delete model.files;
        model.documents = state.documentIDs;

        requestSendMessage(model);
      };

      return new Promise((resolve, reject) => {
        uploadFilesAndSendMessage()
          .then(response => {
            commit('SET_MESSAGE_SENDING', false);
            commit('SET_SENT_STATUS', true);
            commit('CLEAR_DOCUMENT_IDS');
            resolve(response);
          })
          .catch(error => {
            commit('SET_MESSAGE_SENDING', false);
            commit('SET_SENT_STATUS', false);
            console.error(error);
            reject(error);
          });
      });
    }

    commit('auth/SET_HEADERS', 'fueled', { root: true });
    requestSendMessage(model)
      .then(() => {
        commit('SET_MESSAGE_SENDING', false);
        commit('SET_SENT_STATUS', true);
      })
      .catch(error => {
        commit('SET_MESSAGE_SENDING', false);
        commit('SET_SENT_STATUS', false);
        console.error(error);
      });
  },


  async sendDocument({ dispatch, commit }, file) {

    return new Promise((resolve, reject) => {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });

      const data = {
        id: JSON.parse(localStorage.getItem('updateUser')).mdlive_id,
        file: {
          doc: file,
        },
      };

      sendDocument(data)
        .then(async response => {
          await dispatch('sendDocumentMeta', response.data.doc);
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  async sendDocumentMeta({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('auth/SET_HEADERS', 'fueled', { root: true });
      sendDocumentMeta(payload)
        .then(response => {
          commit('SAVE_DOCUMENT_IDS', response.data.id);
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },
  
  async fetchProviderList({ commit }) {
    try {
      const user = JSON.parse(localStorage.getItem('updateUser'));
      const id = user.mdlive_id;
      const data = await requestAllConversations(id);      
      let unreadCount = 0;
      if (data.data.conversations && data.data.conversations.length > 0) {
        unreadCount = data.data.conversations.reduce((acc, conversation) => acc + conversation.unread_messages, 0);
      }
      commit('SET_PROVIDER_LIST', data.data.conversations);
      commit('SET_UNREAD_COUNT', unreadCount);
      return data;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  },

  async clearConversations({ commit }) {
    commit('RESET_UNREAD_COUNT');
    commit('RESET_PROVIDER_LIST');
  },

  clearMessagingStore({ commit }) {
    commit('CLEAR_DOCUMENT_IDS');
    commit('SET_SENT_STATUS', false);
    commit('SET_MESSAGE_SENDING', false);
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/messaging.js